export enum HpmTypesMessages {
  PAGE_TITLE = 'Hall Pass Types',

  BUTTON_LABEL_CREATE = 'Create type',
}
